import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'

import OnlySupperAdmin from '../../components/UI/OnlySupperAdmin/OnlySupperAdmin'
import CanvasIntegration from './Canvas/CanvasIntegration'
import BlackboardIntegration from './Blackboard/BlackboardIntegration'
import Desire2learnIntegration from './Desire2learn/Desire2learnIntegration'
import MoodleIntegration from './Moodle/MoodleIntegration'

const Integrations = () => {
  const { t } = useTranslation('translation')

  return (
    <OnlySupperAdmin>
      <div className="page-mid-wraper integration">
        <div className="interAtions-app tw-mb-6">
          <Typography variant="subtitle1" component="h2">
            {t('Manage Integrations')}
          </Typography>
          <Typography>
            {t('You can manage your connected apps and improve your workflow')}
          </Typography>
        </div>

        <div className="tw-grid tw-grid-cols-3 tw-gap-4 md:max-lg:tw-grid-cols-2 max-md:tw-grid-cols-1">
          <BlackboardIntegration />
          <CanvasIntegration />
          <Desire2learnIntegration />
          <MoodleIntegration />
        </div>
      </div>
    </OnlySupperAdmin>
  )
}

export default Integrations
